import logo from "../assets/argencis-logo.png";

const EMAIL = "webcontact" + "@" + "argencis.com";
const PHONE = "800.745.2215";

export default function Maintenance() {
  return (
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",background:"#ffffff",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>

      <div style={{height:"5px",background:"#2c62d8",width:"100%"}} />

      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"2rem 1.5rem",textAlign:"center"}}>

        <div style={{marginBottom:"1.5rem"}}>
          <img src={logo} alt="Argencis" style={{height:"52px"}} />
        </div>

        <p style={{fontSize:"11px",letterSpacing:"4px",color:"#2c62d8",fontWeight:"700",textTransform:"uppercase",marginBottom:"1.5rem"}}>
        </p>

        <div style={{display:"inline-flex",alignItems:"center",gap:"8px",background:"#fef2f2",border:"1px solid #fecaca",borderRadius:"6px",padding:"8px 14px",marginBottom:"1.25rem"}}>
          <div style={{width:"8px",height:"8px",background:"#dc2626",borderRadius:"50%",flexShrink:0}} />
          <span style={{fontSize:"12px",color:"#dc2626",fontWeight:"600",letterSpacing:"0.3px"}}>
            Site temporarily unavailable
          </span>
        </div>

        <h1 style={{fontSize:"clamp(22px, 4vw, 32px)",fontWeight:"300",color:"#0f172a",lineHeight:"1.3",marginBottom:"0.75rem",letterSpacing:"-0.5px"}}>
          Scheduled maintenance<br />in progress
        </h1>

        <p style={{fontSize:"15px",color:"#64748b",lineHeight:"1.8",maxWidth:"380px",margin:"0 auto 1.25rem"}}>
          We are making improvements to serve you better.{" "}
          The site will be down from <strong style={{color:"#0f172a",fontWeight:"600"}}>May 22, 2026 at 12:00 AM CST</strong> through <strong style={{color:"#0f172a",fontWeight:"600"}}>May 24, 2026</strong>.{" "}
          We will be back on <strong style={{color:"#0f172a",fontWeight:"600"}}>May 25, 2026 at 12:00 AM CST</strong>.
        </p>

        <div style={{width:"40px",height:"1px",background:"#2c62d8",margin:"0 auto 1.25rem"}} />

        <p style={{fontSize:"12px",color:"#94a3b8",letterSpacing:"1px",textTransform:"uppercase",marginBottom:"0.75rem"}}>
          Need help?
        </p>

        <div style={{display:"flex",flexDirection:"column",gap:"12px",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
            <span style={{fontSize:"12px",color:"#94a3b8",width:"40px",textAlign:"right"}}>Email</span>
            <a href={"mailto:" + EMAIL} style={{fontSize:"14px",color:"#0f172a",fontWeight:"500",textDecoration:"none"}}>
              {EMAIL}
            </a>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
            <span style={{fontSize:"12px",color:"#94a3b8",width:"40px",textAlign:"right"}}>Phone</span>
            <a href={"tel:" + PHONE} style={{fontSize:"14px",color:"#0f172a",fontWeight:"500",textDecoration:"none"}}>
              {PHONE}
            </a>
          </div>
        </div>

      </div>

      <div style={{padding:"1.5rem",textAlign:"center",borderTop:"1px solid #f1f5f9"}}>
        <p style={{fontSize:"11px",color:"#cbd5e1",letterSpacing:"1px"}}>
          &copy; 2026 Argencis. All rights reserved.
        </p>
      </div>

    </div>
  );
}
